import axios from "axios";
import { apiNa } from "@/redworks/api/index";
const KAKAO_API = "/v1/kakao";

const restApiKey = apiNa.get(`${KAKAO_API}/restApiKey`);
const adminKey = apiNa.get(`${KAKAO_API}/adminKey`);
const javascriptKey = apiNa.get(`${KAKAO_API}/javascriptKey`);

const kakaoHeader = {
  // "Authorization":"c4913af0f8669515b2ebd179b1e5cd90",
  "Content-type": "application/x-www-form-urlencoded;charset=utf-8",
};

const getKakaoToken = async (code, key, pro, host) => {
  //토큰 받기
  try {
    const data = {
      grant_type: "authorization_code",
      client_id: key, //REST API 키
      redirect_uri: pro + "//" + host + "/signup",
      code: code,
    };

    const queryString = Object.keys(data)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
      .join("&");

    const result = await axios.post(
      "https://kauth.kakao.com/oauth/token",
      queryString,
      { headers: kakaoHeader }
    );

    return result;
  } catch (error) {
    return error;
  }
};

const getKakaoUserInfo = async (token) => {
  //사용자 정보 가져오기
  try {
    const kakaoUser = await axios.get("https://kapi.kakao.com/v2/user/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return kakaoUser;
  } catch (error) {
    return error;
  }
};

const tokenInfo = async (token) => {
  //토큰 정보
  try {
    const toInfo = await axios.get(
      "https://kapi.kakao.com/v1/user/access_token_info",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return toInfo;
  } catch (error) {
    this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
  }
};

export {
  getKakaoToken,
  getKakaoUserInfo,
  tokenInfo,
  restApiKey,
  adminKey,
  javascriptKey,
};
